<script>
    import { getContext, onDestroy, beforeUpdate } from 'svelte'
    import { Typography, InputFile, Modal, BackDrop, Button } from '.'
    import { areEquals, capitalize } from '$lib/utils'
    import { fly } from 'svelte/transition'
    import { writable } from 'svelte/store'
    import { CloseCircle, AddCircle } from '../Icons'
    import { readAthTable } from '$lib/utils'
    import TertiaryButton from './TertiaryButton.svelte'
    import Form from './Form.svelte'
    import InputText from './InputText.svelte'
    import InputDate from './InputDate.svelte'
    import CheckBox from './CheckBox.svelte' /** @param {any} value */
    import SelectX from './SelectX.svelte'
    export let value = null
    export let label = null
    export let required = false
    export let disabled = false
    export let validation = null
    export let name = null
    export let valid = true
    export let schema = null
    export let data = []
    export let buttonLabel = 'Agregar item'
    export let customTypes = {}
    export let autoform = true
    if (value !== null) {
        if (typeof value === 'string') {
            value = readAthTable(value)
        }
        console.log(value)
    } else {
        value = []
    }
    if (value instanceof Array && value.every((x) => typeof x === 'object')) {
        data = structuredClone(value)
    }
    if (schema === null) {
        // Esquema automatico
        schema = Object.fromEntries(
            Array.from(
                data.reduce((allKeys, item) => {
                    Object.keys(item).forEach(async (x) => {
                        await allKeys.add(x)
                    })
                    return allKeys
                }, new Set())
            ).map((h) => [
                h.toLowerCase(),
                {
                    label: capitalize(h).replace(/_/g, ' '),
                    type: 'string',
                    render: (x) => x || '-',
                    validation: (_) => true,
                    props: {},
                    hidden: false,
                },
            ])
        )
    } else if (typeof schema === 'object') {
        // Normalizar esquema
        console.log('NormalizarEsquema')
        schema = Object.entries(schema)
            .map(([k, v]) => {
                let tmp
                if (typeof v === 'string') {
                    tmp = {
                        type: v,
                        label: capitalize(k).replace(/_/g, ' '),
                        validation: (_) => true,
                        render: (x) => x || '-',
                        props: {},
                    }
                } else if (typeof v === 'object')
                    tmp = {
                        type: 'string',
                        label: capitalize(k).replace(/_/g, ' '),
                        render: (x) => x || '-',
                        validation: (_) => true,
                        props: {},
                        ...v,
                    }
                return [k, tmp]
            })
            .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
    }
    // console.log({schema})
    let formData = getContext('formData')
    let create = false
    const datast = writable(data)
    function deleteBuilder(i) {
        return function () {
            datast.update((n) =>
                n.filter((x, p) => {
                    return p !== i
                })
            )
        }
    }
    $: data = $datast
    $: raw = data
    $: value = data
    $: body = Object.entries(schema).filter(([_, v]) => !v.hidden)
    $: headers = body
        .filter(([_, v]) => !v.hidden)
        .map(([k, v]) => ('label' in v ? v.label : k))

    $: if (value) {
        valid = validation ? validation(value) : null
        console.log('execute validation: ', valid)
    }

    $: Types = {
        string: InputText,
        number: InputText,
        file: InputFile,
        date: InputDate,
        boolean: CheckBox,
        select: SelectX,
        ...customTypes,
    }

    beforeUpdate(() => {
        if (!areEquals(data, $datast)) {
            $datast = data
        }
        if (!areEquals(value, $datast)) {
            $datast = value
        }
    })

    // Form actions
    $: if (((data && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: !!valid,
                            validation: !!validation,
                            required,
                            value: data,
                            label,
                        },
                    ],
                ])
            )
        })
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
    let entryValid = false
    let entryData
    $: console.log({ entryData, entryValid })
</script>

<table width="100%" border={0} class:disabled>
    <tr class="header">
        {#each headers as column}
            <td
                ><Typography type="caption" style="margin: 0" color="grey-800"
                    >{column}</Typography
                ></td
            >
        {/each}
        <td style="width: 25px"></td>
    </tr>
    <tbody>
        {#if $datast.length > 0}
            {#each $datast as row, i}
                <tr transition:fly={{ x: 50 }}>
                    {#each body as [id, { render, validation }]}
                        <td>
                            <Typography
                                type="body"
                                color={validation(row[id]) ? 'black' : 'red'}
                            >
                                {@html render(row[id] || '-')}
                            </Typography>
                        </td>
                    {/each}
                    <td
                        style=" margin: 0; padding: 0; justify-content: center; align-items: center; height: auto; position: relative"
                    >
                        {#if !disabled}
                            <p
                                style="cursor: pointer; margin: 0; padding: 0"
                                on:keypress={(_) => _}
                                on:click={deleteBuilder(i)}
                            >
                                <CloseCircle size={20} />
                            </p>
                        {/if}
                    </td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td
                    colspan={headers.length}
                    style="text-align: center; color: var(--color-grey-800)"
                    >No hay elementos</td
                >
            </tr>
        {/if}
    </tbody>
    {#if !create}
        {#if !disabled && autoform}
            <tr class="last">
                <td style="text-align: center" colspan={headers.length}>
                    <TertiaryButton
                        on:click={(_) => (create = true)}
                        label={buttonLabel}
                        icon={AddCircle}
                    />
                </td>
            </tr>
        {/if}
    {:else}
        <BackDrop visible={create} style="position: fixed;">
            <Modal
                title={buttonLabel}
                on:clickout={(_) => (create = false)}
                on:close={(_) => (create = false)}
                style="margin-top: 70px; height: calc(75% - 70px)"
            >
                <Form bind:incorrectFields={entryValid} bind:data={entryData}>
                    {#each Object.entries(schema) as [id, { label, type, props, validation }]}
                        {@const component =
                            type in Types ? Types[type] : InputText}
                        <svelte:component
                            this={component}
                            name={id}
                            {label}
                            {...props}
                            {validation}
                        />
                    {/each}
                </Form>
                <svelte:fragment slot="buttonSet">
                    <Button type="other" on:click={(_) => (create = false)}
                        >Cancelar</Button
                    >
                    <Button
                        on:click={(_) => {
                            datast.update((d) => [...d, entryData])
                            create = false
                        }}
                        disabled={!Object.values(entryValid).reduce(
                            (res, { valid }) => res && valid,
                            true
                        )}
                        label="Agregar"
                    />
                </svelte:fragment>
            </Modal>
        </BackDrop>
    {/if}
</table>

<style>
    table {
        width: 100%;
        /* position: absolute; */
        max-width: 100%;
        border-style: none;
        border-width: 0;
        border-collapse: collapse;
        border-spacing: 0;
        table-layout: fixed;
    }
    table.disabled {
        opacity: 0.5;
    }
    td {
        padding: 0 0 0 24px;
    }
    tr.header {
        height: 42px;
        background: var(--color-grey-150);
    }
    tr {
        height: 72px;
        background: var(--color-white);
        border-bottom: 1px solid var(--color-grey-300);
    }
    tr.last {
        border: none;
        height: 42px;
    }

    /* .void {
    color: var(--color-grey-150);
  } */
</style>
